/**
 * Skeleton — Shimmer-Placeholder im Design-D-Stil.
 *
 * Drei Varianten:
 *   - rect:   Standard, abgerundet (kleine Boxen, Bars, Cards)
 *   - text:   schlanker Balken in Text-Höhe
 *   - circle: rund (Avatare, Indicator-Dots)
 */

import type { CSSProperties } from 'react'

interface SkeletonProps {
  width?: number | string
  height?: number | string
  variant?: 'rect' | 'text' | 'circle'
  className?: string
  style?: CSSProperties
}

export function Skeleton({
  width,
  height,
  variant = 'rect',
  className,
  style,
}: SkeletonProps) {
  const radius =
    variant === 'circle' ? '50%' : variant === 'text' ? 4 : 6
  const finalHeight = height ?? (variant === 'text' ? 12 : 16)
  const finalWidth = width ?? '100%'
  return (
    <span
      className={`skeleton${className ? ` ${className}` : ''}`}
      aria-hidden="true"
      style={{
        width: finalWidth,
        height: finalHeight,
        borderRadius: radius,
        display: variant === 'circle' ? 'inline-block' : 'block',
        ...style,
      }}
    />
  )
}
